var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEyeOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 9.00999C21.6 10.7 21.6 13.3 20.2 14.99C18.2 17.4 15.27 18.94 12 18.94C8.73001 18.94 5.81 17.41 3.8 14.99C2.4 13.3 2.4 10.7 3.8 9.00999C5.8 6.59999 8.73001 5.06 12 5.06C15.27 5.06 18.19 6.58999 20.2 9.00999Z",
    stroke: "#918F93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 9.00999C21.6 10.7 21.6 13.3 20.2 14.99C18.2 17.4 15.27 18.94 12 18.94C8.73001 18.94 5.81 17.41 3.8 14.99C2.4 13.3 2.4 10.7 3.8 9.00999C5.8 6.59999 8.73001 5.06 12 5.06C15.27 5.06 18.19 6.58999 20.2 9.00999Z",
    stroke: "#918F93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 15.08C13.7009 15.08 15.0799 13.701 15.0799 12C15.0799 10.2989 13.7009 8.91998 11.9999 8.91998C10.2989 8.91998 8.91992 10.2989 8.91992 12C8.91992 13.701 10.2989 15.08 11.9999 15.08Z",
    stroke: "#918F93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeOn);
export default __webpack_public_path__ + "static/media/ic-eye-on.3336e3bba854bbe3123f79980d9ab4ef.svg";
export { ForwardRef as ReactComponent };